<template>
  <div class="blog-cta">
    <img class="app-icon" alt="Wotive app icon" src="../../assets/wotive-icon.svg">
    <h2>Wotive</h2>
    <p>Free Social Gym Tracker</p>
    <div class="download-icons">
      <a target="_blank" :href="appStoreLink"><img alt="Download Wotive gym workout tracker app ios app store" src="../../assets/landing-page/appstore.svg" /></a>
      <a target="_blank" :href="googleAppStoreLink"><img alt="Download Wotive gym workout tracker app android app store" src="../../assets/landing-page/googleplay.svg" /></a>
    </div>
  </div>
</template>

<script>
import { APP_STORE_LINK, GOOGLE_PLAY_STORE_LINK } from '@/constants';

export default {
  name: 'AboutWotive',
  computed: {
    appStoreLink() {
      return APP_STORE_LINK;
    },

    googleAppStoreLink() {
      return GOOGLE_PLAY_STORE_LINK;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.blog-cta {
  .app-icon {
    width: 64px;
    height: 64px;
  }

  h2 {
    font-size: 16px;
    font-weight: bold;
    color: $sec1;
    padding: 0;
    margin: 0;
  }

  p {
    margin: 0;
    padding: 0;
    margin-bottom: 8px;
  }

  .download-icons {
    img {
      height: 40px;
      margin-right: 8px;
    }
  }
}
</style>